/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SearchType } from "~/generated/graphql";

type EstateCategory = {
  typename: string;
  color: string;
  label: string;
  tab?: boolean;
};

export const estateCategories: Record<string, EstateCategory> = {
  Resource: {
    typename: "resource",
    color: "#F1C40F",
    label: "Estate Record",
    tab: false,
  },
  CloudResource: {
    typename: SearchType.Resource,
    color: "#F1C40F",
    label: "Cloud Resource",
    tab: false,
  },
  CostResource: {
    typename: SearchType.Cost,
    color: "#27AE60",
    label: "Cost Resource",
    tab: false,
  },
  EXTERNAL: {
    typename: "External",
    color: "#8400ff",
    label: "External",
    tab: false,
  },
} as const;
